import Swal from 'sweetalert2';

// Find the form element
const formimg = document.querySelector('.formWithImage__content--form');

if(formimg){
    // Do something on a successful ajax submit
    formimg.addEventListener('freeform-ajax-success', function(event) {
        Swal.fire(
            'Formulario enviado!',
            'El formulario fue enviado con éxito, pronto nos pondremos en contacto contigo.',
            'success'
        );
    });
    formimg.addEventListener('freeform-ajax-error', function(event) {
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Parece que hubo un error al enviar el formulario, inténtalo de nuevo.'
        });
    });
      
}
